<main class="products-page container">
  <!-- filters -->
  <pwj-products-filters class="products-page__filters"></pwj-products-filters>
  <!-- products -->
  <pwj-cards-list class="products-page__products"></pwj-cards-list>
</main>
